module.exports = __webpack_public_path__ + "img/icon-facebook.5f95149b.svg";